import { render, staticRenderFns } from "./VictimDetails.vue?vue&type=template&id=0b48927c&"
import script from "./VictimDetails.vue?vue&type=script&lang=js&"
export * from "./VictimDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports